<template>
  <v-card flat class="compound_preview">
    <v-data-table
      :headers="headers"
      :items="dataArray"
      hide-default-footer
      class="transparent"
      mobile-breakpoint="0"
    >
      <template v-slot:item.structure="{ item }">
        <SmilesDrawer
          :id="`preview`"
          :smiles="item.canonical"
          :width="250"
          :height="200"
          v-show="!loading && !item.error"
          ref="drawer"
        ></SmilesDrawer>
        <div style="height: 200px" v-show="loading || item.error"></div>
      </template>
      <template v-slot:item.smiles="{ item }">
        <div>
          <span class="compound_error">{{ errorMsg }}</span
          ><br />
        </div>
        <span v-show="!loading">{{ item.canonical }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import SmilesDrawer from "@/components/SmilesDrawer";

export default {
  name: "CompoundPreview",
  components: {
    SmilesDrawer,
  },
  data() {
    return {
      data: [],
      checkingData: {},
      smiles: null,
      canonical: null,
      loading: false,
      delayHandler: null,
      errorMsg: null,
      ruleRequired: (v) => !!v || this.$t("global.required"),
    };
  },
  computed: {
    dataArray: {
      get() {
        if (this.smiles) {
          return [
            {
              smiles: this.smiles,
              canonical: this.canonical || this.smiles,
              name: "",
            },
          ];
        } else {
          return [];
        }
      },
      set(val) {
        this.$emit(
          "input",
          val.find((v) => v)
        );
      },
    },
    headers() {
      return [
        {
          text: this.$t("start.structure"),
          value: "structure",
          width: "55%",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("start.smiles"),
          value: "smiles",
          width: "45%",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    onCheck(val) {
      this.data = [
        {
          smiles: val,
        },
      ];
      this.check(this.data);
    },
    clear() {
      this.data = [];
      this.checkingData = {};
      this.smiles = null;
      this.canonical = null;
      this.errorMsg = null;
    },
    check(smilesArr) {
      this.clear();
      if (!this.loading) {
        this.loading = true;
        try {
          const token = this.$root.userToken;
          this.$ajax(this.$root.api + "/check", {
            method: "post",
            headers: {
              Authorization: token,
              "Content-Type": "application/json; charset=UTF-8",
            },
            data: smilesArr,
          })
            .then((res) => {
              if (res.data != false) {
                let d = JSON.parse(JSON.stringify(res.data || [])) || {};
                console.log(d);
                if (d.error == undefined) {
                  this.canonical = this.smiles = d.canonical;
                  this.checkingData = d;
                  this.$emit("done", this.canonical);
                } else {
                  this.canonical = this.smiles = d.smiles;
                  this.errorMsg = d.error;
                  this.checkingData = d;
                  d.canonical = d.smiles;
                  this.$emit("done", false);
                }
                
              } else {
                this.$root.$somethingWrong(res.data);
                this.$emit("done", false);
              }
              this.loading = false;
            })
            .catch((err) => {
              this.errorMsg = err;
              this.$emit("done", false);
            });
        } catch (err) {
          this.$root.$toast.popup(err.message);
        }
      }
    },
  },
};
</script>
